import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Checkbox, FormActions } from '../../common/components/formControls';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, canConfigureSystemAlerts, systemAlertEventTypes, initialValues, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{canConfigureSystemAlerts && <Panel>
				<Panel.Heading>{t('Profile_SystemAlerts')}</Panel.Heading>
				<Panel.Body>
					<div style={{ marginBottom: '20px' }}><em>{t('Profile_SystemAlertEvents_Hint')}</em></div>
					{systemAlertEventTypes && systemAlertEventTypes.map(x => <Field name={`systemAlertEvents.${x.name}`} component={Checkbox} disabled={isReadonly} horizontal label={x.displayName} />)}
				</Panel.Body>
			</Panel>}
			<FormActions horizontal>
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'userSettings', enableReinitialize: true })(withTranslation()(SettingsForm));

